import type {
  CheckoutAllowedResponse,
  CheckoutType,
} from 'src/api/endpoints/storeApi.types';

export const CHECKOUT_OFFER_TYPES: Record<string, CheckoutType> = {
  CONNECT: 'connectOffer',
  DM: 'dmOffer',
  WINBACK: 'winbackOffer',
  STORE: 'store',
};

// Consider rewriting to use the API types as a return type instead of re-inventing the wheel here
export const getActiveOffer = (
  checkoutAllowedData: CheckoutAllowedResponse['data'] | undefined | null
): {
  checkoutType: CheckoutType;
  expirationDate: string | null;
  freeTrialLengthDays: number;
} => {
  if (checkoutAllowedData?.connectOffer?.allowed) {
    return {
      checkoutType: CHECKOUT_OFFER_TYPES.CONNECT,
      expirationDate: checkoutAllowedData.connectOffer.expiresAt,
      freeTrialLengthDays: checkoutAllowedData.connectOffer.freeTrialLengthDays,
    };
  }
  if (checkoutAllowedData?.dmOffer?.allowed) {
    return {
      checkoutType: CHECKOUT_OFFER_TYPES.DM,
      expirationDate: checkoutAllowedData.dmOffer.expiresAt,
      freeTrialLengthDays: checkoutAllowedData.dmOffer.freeTrialLengthDays,
    };
  }
  if (checkoutAllowedData?.winbackOffer?.allowed) {
    return {
      checkoutType: CHECKOUT_OFFER_TYPES.WINBACK,
      expirationDate: checkoutAllowedData.winbackOffer.expiresAt,
      freeTrialLengthDays: checkoutAllowedData.winbackOffer.freeTrialLengthDays,
    };
  }
  return {
    checkoutType: CHECKOUT_OFFER_TYPES.STORE,
    expirationDate: null,
    freeTrialLengthDays: 0,
  };
};
